import Capability from './Capability';

export default Capability;
